import { render, staticRenderFns } from "./emba.vue?vue&type=template&id=bd32196a"
import script from "./emba.vue?vue&type=script&lang=js"
export * from "./emba.vue?vue&type=script&lang=js"
import style0 from "./emba.vue?vue&type=style&index=0&id=bd32196a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports